import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCup: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cup, tea, coffee, mug"><path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H16.25C16.6642 3 17 3.33579 17 3.75V6H20.25C20.6642 6 21 6.33579 21 6.75V12.25C21 12.6642 20.6642 13 20.25 13H17V20.25C17 20.6642 16.6642 21 16.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM17 11.5H19.5V7.5H17V11.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCup;
